var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.item === 1 ? _vm.$t('yes') : _vm.$t('no')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }